export type SingleSearchNumber = {
	bAccountId: string;
	upAccountId: string;
	accountNum: string;
	accountType: string;
	billingType: string;
	accountId: string;
	accountCategory: string
};

const model: types.models.InputModel = {
	bAccountId: 'bAccountId',
	upAccountId: 'upAccountId',
	accountNum: 'accountNum',
	accountType: 'accountType',
	billingType: 'billingType',
	accountId: 'accountId',
	accountCategory: 'accountCategory'
};

export default model;
